import SetPrimaryButton from './SetPrimaryButton';

export default SetPrimaryButton;
